import { PROCESS_STEPS } from "../../lib/data";

export default function Process() {
  return (
    <section id="ablauf" data-testid="process-section" className="marble-dark py-24 md:py-32 text-[#F8F5EF] relative overflow-hidden">
      <div className="container-x relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16 md:mb-20">
          <div className="md:col-span-6 reveal">
            <div className="flex items-center gap-3 mb-6">
              
              <span className="overline text-[#FFA500]">Ablauf</span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
              In vier <br />
              <span className="italic font-light">Schritten</span> zum <span className="gold-text italic">Bild</span>.
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 md:pt-12 reveal">
            <p className="text-[15px] leading-relaxed text-[#A8A59E] font-light">
              Transparent, planbar, professionell. Von der ersten Anfrage bis zur
              finalen Lieferung ist jederzeit klar, was wann passiert.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4">
          {PROCESS_STEPS.map((s, idx) => (
            <div
              key={s.num}
              data-testid={`process-step-${s.num}`}
              className={`p-8 md:p-10 reveal relative ${
                idx < PROCESS_STEPS.length - 1 ? "md:border-r border-[#2A2A2A]" : ""
              } ${idx % 2 === 1 ? "md:translate-y-12" : ""}`}
            >
              <div className="ticker-num text-7xl md:text-8xl text-[#FFA500] leading-none">
                {s.num}
              </div>
              <h3 className="mt-8 font-display text-2xl md:text-[28px]">{s.title}</h3>
              <p className="mt-4 text-[14px] leading-relaxed text-[#A8A59E] font-light">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
